// extracted by mini-css-extract-plugin
export default {"wrapper":"kycPreview_wrapper__4+Mhd","title":"kycPreview_title__ePSW7"};